export const getRegistrationNumberValidatorFunction = function (value) {
  let inProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const regex = new RegExp(inProgress ? '(^\\d{0,14}$)' : '(^\\d{14}$)');
  if (value.match(regex)) {
    return null;
  }
  return 'error.invalidRegistrationNumber.FRANCE';
};